import {CanActivateFn, Router} from '@angular/router';
import {inject} from "@angular/core";
import {getAuth, onAuthStateChanged} from "firebase/auth";

export const authGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const auth = getAuth();

  // Check if user is logged in
  return new Promise<boolean>((resolve=> {
    onAuthStateChanged(auth, (user)=> {
      // if true, user has access to the website
      if(user){
        resolve(true);
      }else{
        // if false, user will always be redirected to the login page
        router.navigate(['/landing']);
        resolve(false);
      }
    })
  }))
};
